import React, { useState } from "react";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import { TableSelectRow } from "../../../components/Table/TableSelectRow";
import { FooterTable } from "../../../components/Table/FooterTable";
import {
  IColumn,
  ICommandBarItemProps,
  IDetailsListStyleProps,
  IDetailsListStyles,
  IStyleFunctionOrObject,
  Icon,
  Stack,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import IconHelper from "../../../utils/helpers/iconHelper";
import { useTableEquipos } from "../../../hooks/TablasHooks/useTableEquipos";
import { PanelAddEquipos } from "./PanelAddEquipos";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";
import { IActualizarEquipo } from "../../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";
import { PanelActualizarEquipo } from "./PanelActualizarEquipo";
const classNames = mergeStyleSets({
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
});

export const ConfigEquipoCheckList = () => {
  const styleTable: IStyleFunctionOrObject<
    IDetailsListStyleProps,
    IDetailsListStyles
  > = {
    root: {
      height: "calc(100vh - 9rem)",
    },
  };
  const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const {
    loading,
    dataTeble,
    paginacion,
    searchBoxRefTable,
    _onkeyUpSearch,
    onClickRefresh,
    onChangeSkip,
  } = useTableEquipos();

  const [
    isOpenPanelEditEquipo,
    { setTrue: openPanelEditEquipo, setFalse: onDismissPanelEditEquipo },
  ] = useBoolean(false);

  const [modelActualizarEquipo, setModelActualizarEquipo] =
    useState<IActualizarEquipo>({
      EquipoId: "",
      Nombre: ""
    });
  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: () => {
        openPanel();
      },
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        onClickRefresh();
      },
    },
  ];

  const column: IColumn[] = [
    {
      key: "tipoEquipo",
      name: "Nombre Equipo",
      fieldName: "nombre",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "modelo",
      name: "Modelo",
      fieldName: "modelo",
      minWidth: 260,
      maxWidth: 260,
      isResizable: true,
    },
    {
      key: "horometro",
      name: "Horometro",
      fieldName: "horometro",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "fechaCreado",
      name: "Fecha de Creación",
      fieldName: "fechaCreada",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "ultVerificacione",
      name: "Última Verificación",
      fieldName: "ultimaVerificacion",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item) => (
        <>

          <TooltipHost content={"Editar"}>
            <Icon
              iconName="edit"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                setModelActualizarEquipo({
                  ...modelActualizarEquipo,
                  EquipoId: item.equipoId,
                  Nombre: item.nombre
                });
                openPanelEditEquipo();
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Nombre de Equipo"
            componentRef={searchBoxRefTable}
            Titulo="Equipos"
            SubTitulo="Gestión de Equipos"
            onKeyUp={_onkeyUpSearch}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          leftBar={_items}
          data={dataTeble}
          column={column}
          isLoading={loading}
          footerPagination={
            <PaginationFooterC
              paginacion={paginacion}
              onChangePagina={(e) => {
                onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>
      <PanelAddEquipos
        isOpen={isOPenPanel}
        onDismiss={dismissPanel}
        onRefreshTable={onClickRefresh}
      />
      <PanelActualizarEquipo
        isOpen={isOpenPanelEditEquipo}
        onDismiss={onDismissPanelEditEquipo}
        modelActualizarEquipo={modelActualizarEquipo}
        onRefreshTable={onClickRefresh}
      />
    </>
  );
};
